import styles from "../../Styles/NoteTitle.module.css";

const NoteTitle = ({ title }) => {
  return <h2 className={styles.title}>{title}</h2>;
};
export default NoteTitle;
